import { valueZHCN } from '@/i18n';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
const { persistAtom } = recoilPersist({
  key: 'recoil-persist', // this key is using to store data in local storage
  storage: localStorage // configurate which storage will be used to store the data
});

const userInfo = atom({
  key: 'userInfo',
  default: {},
  effects_UNSTABLE: [persistAtom]
});

const userList = atom({
  key: 'userList',
  default: []
});

const i18nLang = atom({
  key: 'i18nLang',
  default: localStorage.getItem('i18nextLng') ?? valueZHCN
});

const routerList = atom({
  key: 'routerList',
  default: []
});
const dictionaryList = atom({
  key: 'dictionaryList',
  default: {}
});
const tagName = atom({
  key: 'tagName',
  default: []
});
const ticketSwitch = atom({
  key: 'ticketSwitch',
  default: true
});
const ticketDetail = atom({
  key: 'ticketDetail',
  default: {}
});
const keyWord = atom({
  key: 'keyWord',
  default: ''
});

const roleList = atom({
  key: 'roleList',
  default: {}
});

const systemDict = atom({
  key: 'systemDict',
  default: []
});

// const newsNumber = atom({
//   key: 'newsNumber',
//   default: 0
// });

export {
  dictionaryList,
  i18nLang,
  keyWord,
  routerList,
  tagName,
  ticketDetail,
  ticketSwitch,
  userInfo,
  userList,
  roleList,
  systemDict
};
